import axios from 'axios'
import Swal from 'sweetalert2'


export default function onSubmitEducation(user, setEditBiodata, setBiodata, setDisabled, province, districts) {
    Swal.showLoading()
    const token = localStorage.getItem('token');
    let biodata = user
    let updateEducation = {
        competency: biodata.competency,
        edu_institution: biodata.edu_institution,
        edu_degree: biodata.edu_degree,
        edu_major: biodata.edu_major,
        edu_grad_year: biodata.edu_grad_year,
        edu_grade: biodata.edu_grade,
    }
    var config = {
        method: 'post',
        url: `${process.env.REACT_APP_API}/participant/profile/update/education`,
        headers: { token: token },
        data: {
            education: updateEducation
        }
    };

    axios(config)
        .then(function (response) {
            setEditBiodata(false)
            setDisabled(true)
            setBiodata(response.data)
            Swal.close()
        })
        .catch(function (error) {
            console.log(error);
        });
}